exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#unemployed-app h5{font-weight:700;font-size:1.3rem;color:#4d4d4d;margin:1.5rem 0 1rem}#unemployed-app .question{margin:1.25rem 0 .5rem;font-weight:700;color:#4d4d4d;font-size:1rem}#unemployed-app input.short,#unemployed-app input[type=date]{width:100%;max-width:200px;box-sizing:border-box}#unemployed-app button[type=submit]{font-weight:700}#unemployed-app .small-11{margin-bottom:15px}.mx-datepicker-popup .mx-btn{background-color:transparent!important}.validation-error{color:red!important}.redColoredText{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-19aa5d4a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 293
// module chunks = 0